module.exports = __webpack_public_path__ + "img/nasolabial_male_wide.6965c30a.png";